__turbopack_context__.v({
  "list": "ko2lPG_list",
  "mobileFilters": "ko2lPG_mobileFilters",
  "mobileHeader": "ko2lPG_mobileHeader",
  "root": "ko2lPG_root",
  "title": "ko2lPG_title",
  "titleCount": "ko2lPG_titleCount",
  "titleGroup": "ko2lPG_titleGroup",
  "toolbar": "ko2lPG_toolbar",
});
